import { render } from "./WaterPointWellAlert.vue?vue&type=template&id=e2025ea2"
import script from "./WaterPointWellAlert.vue?vue&type=script&lang=js"
export * from "./WaterPointWellAlert.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/www.alb-bayern.de/bottle/www/apps/alb_development/frontend/mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/waterpoint/WaterPointWellAlert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2025ea2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2025ea2', __exports__)) {
    console.log('reload')
    api.reload('e2025ea2', __exports__)
  }
  
  module.hot.accept("./WaterPointWellAlert.vue?vue&type=template&id=e2025ea2", () => {
    console.log('re-render')
    api.rerender('e2025ea2', render)
  })

}


export default __exports__